<template>
  <div>
    <div class="h1">
      <div class="w1">
        <div class="log">
          <img src="../../assets/img/pagess/gdd102/logo.png" alt="" />
        </div>
        <span>投资有风险 入市需谨慎</span>
      </div>
      <div class="heng"></div>
      <div class="w">
        <div class="l">
          <div class="lis1">
            <img src="../../assets/img/pagess/gdd102/h1-1.png" alt="" />
          </div>
          <div class="lis2">看盘·选股·更快一步！</div>
          <div class="lis3">
            <img
              class="btn"
              src="../../assets/img/pagess/gdd102/btn.png"
              alt=""
              @click="to_xaizai()"
            />
          </div>
          <div class="lis4">
            1键下载 · 免费注册 · 终身使用
          </div>
          <div class="lis5">
            <img src="../../assets/img/pagess/gdd102/h1-3.png" alt="" />
          </div>
        </div>
        <div class="r">
          <div class="lis1">
            <img src="../../assets/img/pagess/gdd102/h1-2.png" alt="" />
          </div>
          <div class="lis2 btn" @click="to_xaizai()">
            <img src="../../assets/img/pagess/gdd102/btn2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="h2">
      <div class="w1">
        <div class="lis1">
          <div class="sss">
            <div class="text1">全新四大 炒股优选功能 个股反转信号凸显</div>
            <div class="text2">
              聚焦基本面、技术面、资金面、消息面四位一体更全面
            </div>
          </div>
        </div>
        <div class="lis2">
          <div class="liss">
            <div class="img1">
              <img src="../../assets/img/pagess/gdd102/h2-3.png" alt="" />
            </div>
            <div class="text1"><span>判势：</span>大盘趋势轻松判断</div>
          </div>
          <div class="liss">
            <div class="img1">
              <img src="../../assets/img/pagess/gdd102/h2-4.png" alt="" />
            </div>
            <div class="text1"><span>动能二号：</span>特色指标寻找多空信号</div>
          </div>
          <div class="liss">
            <div class="img1">
              <img src="../../assets/img/pagess/gdd102/h2-5.png" alt="" />
            </div>
            <div class="text1"><span>五大策略池：</span>每日精选强势股</div>
          </div>
          <div class="liss">
            <div class="img1">
              <img src="../../assets/img/pagess/gdd102/h2-6.png" alt="" />
            </div>
            <div
              class="text1"
              style="text-align: right;  width:250px; margin-top: 5px;"
            >
              <span>热点星空：</span>结合消息面，站在风口上筛选强势股
            </div>
          </div>
        </div>
        <div class="lis3" ref="obtain">
          <img src="../../assets/img/pagess/gdd102/h2-7.png" alt="" />
          <span>今日风口已更新</span>
        </div>
        <div @click="to_xaizai()" class="lis4 btn">免费下载体验</div>
      </div>
      <div class="w2">
        <div class="lis1">
          <div class="sss">
            <div class="text1">
              多维度 <span>监控强势股机会</span> 监测资金异动
            </div>
            <div class="text2">
              聚焦基本面、技术面、资金面、消息面四位一体更全面
            </div>
          </div>
        </div>
        <div class="lis2">
          <div class="liss1">
            <div class="text1">选股利器——六维共振：特色指标盘前甄选强势股</div>
            <div class="text2">
              上证3500压力位行情反复震荡，哪些强势股会逆势上涨?
            </div>
            <div class="text3">
              <img src="../../assets/img/pagess/gdd102/h2-8.png" alt="" />
            </div>
          </div>
          <div class="liss2">
            <div class="l">
              <span>选真龙 不惧调整</span>
              <img src="../../assets/img/pagess/gdd102/h2-9.png" alt="" />
              <div class="lis-1">
                <div
                  class="text1"
                  style="font-weight: 700;font-size:24px;  padding-top:20px;  margin-bottom: 10px;"
                >
                  风口提示
                </div>
                <div class="text2" style=" margin-bottom: 5px;">
                  无论上涨、震荡、下跌任何形态，
                </div>
                <div class="text3">实时捕捉当日强势股机会，辅助选股</div>
                <div
                  class="text4"
                  style="font-weight: 700;font-size: 24px;  padding-top: 20px;  margin-bottom: 10px;"
                >
                  盘中直播
                </div>
                <div class="text5">
                  专业解析盘面热点，缩小选股范
                </div>
                <div class="text6">围</div>
              </div>
            </div>
            <div class="r">
              <img src="../../assets/img/pagess/gdd102/h2-11.png" alt="" />
            </div>
          </div>
          <div class="liss3">
            <img src="../../assets/img/pagess/gdd102/h2-7.png" alt="" />
            <span>今日风口已更新</span>
          </div>
          <div @click="to_xaizai()" class="liss4 btn">免费下载体验</div>
        </div>
        <div class="lis3">
          <div class="liss1">
            多空建议——动能二号：快速判断超短周期资金上攻强弱
          </div>
          <div class="liss2">
            一买就跌？一卖就涨？寻找强势股多空时机！
          </div>
          <img
            class="liss3"
            src="../../assets/img/pagess/gdd102/h2-8.png"
            alt=""
          />
          <div class="liss4">
            <div class="r">
              <img src="../../assets/img/pagess/gdd102/h2-12.png" alt="" />
            </div>
            <div class="l">
              <span>好股票 还需好操作</span>
              <img src="../../assets/img/pagess/gdd102/h2-9.png" alt="" />
              <div class="lis-1">
                <div
                  class="text1"
                  style="font-weight: 700;font-size:24px;  padding-top:20px;  margin-bottom: 10px;"
                >
                  操作讲纪律
                </div>
                <div class="text2" style=" margin-bottom: 5px;">
                  动能翻红，提示机会
                </div>
                <div class="text3">动能翻黄，警示风险</div>
                <div
                  class="text4"
                  style="font-weight: 700;font-size: 24px;  padding-top:14px;  margin-bottom: 10px;"
                >
                  离场预警
                </div>
                <div class="text5" style=" margin-bottom: 10px;">
                  洞悉资金动态，买卖快人一步
                </div>
              </div>
            </div>
          </div>
          <div class="liss5">
            <img src="../../assets/img/pagess/gdd102/h2-7.png" alt="" />
            <span>今日风口已更新</span>
          </div>
          <div @click="to_xaizai()" class="liss6 btn">免费下载体验</div>
        </div>
        <div class="lis4">
          <div class="liss1">
            <div class="text1">
              顺势调仓——擒龙环境：研判投资氛围，识别系统风险及机会
            </div>
            <div class="text2">
              上证3500压力位行情反复震荡，哪些强势股会逆势上涨?
            </div>
            <div class="text3">
              <img src="../../assets/img/pagess/gdd102/h2-8.png" alt="" />
            </div>
          </div>
          <div class="liss2">
            <div class="l">
              <span>判大势 知强弱</span>
              <img src="../../assets/img/pagess/gdd102/h2-9.png" alt="" />
              <div class="lis-1">
                <div
                  class="text1"
                  style="font-weight: 700;font-size: 24px;  padding-top: 20px;  margin-bottom: 10px;"
                >
                  大盘信号
                </div>
                <div class="text2">
                  红色表示春天，波段上涨区域
                </div>
                <div class="text2">
                  黄色表示夏天，横盘震荡区域
                </div>
                <div class="text2">
                  绿色表示秋天，弱势下跌区域
                </div>
                <div class="text2">
                  蓝色表示冬天，超跌反弹区域
                </div>
                <div
                  class="text4"
                  style="font-weight: 700;font-size: 24px;  padding-top: 10px;  margin-bottom: 10px;
                    "
                >
                  仓位配置
                </div>
                <div class="text5">
                  从基本面、资金面、市场情绪、大盘
                </div>
                <div class="text5">走势4个方面定时更新仓位管理建议</div>
                <div class="text6">应对市场风险</div>
              </div>
            </div>
            <div class="r">
              <img src="../../assets/img/pagess/gdd102/h2-19.png" alt="" />
            </div>
          </div>
          <div class="liss3">
            <img src="../../assets/img/pagess/gdd102/h2-7.png" alt="" />
            <span>今日风口已更新</span>
          </div>
          <div @click="to_xaizai()" class="liss4 btn">免费下载体验</div>
        </div>
      </div>
      <div class="w3">
        <div class="lis1">更多亮点，等你体验</div>
        <div class="lis2">
          <div class="qq">
            <img src="../../assets/img/pagess/gdd102/h2-15.png" alt="" />
            <div class="text" style="margin-bottom: 10px;">实时股价预警</div>
            <div class="text">操作快人一步</div>
          </div>
          <div class="qq">
            <img src="../../assets/img/pagess/gdd102/h2-16.png" alt="" />
            <div class="text" style="margin-bottom: 10px;">个股龙虎复盘</div>
            <div class="text">识别主力动向</div>
          </div>
          <div class="qq">
            <img src="../../assets/img/pagess/gdd102/h2-17.png" alt="" />
            <div class="text" style="margin-bottom: 10px;">3分钟免费课</div>
            <div class="text">实战选股更科学</div>
          </div>
          <div class="qq">
            <img src="../../assets/img/pagess/gdd102/h2-18.png" alt="" />
            <div class="text" style="margin-bottom: 10px;">
              执业优秀投顾坐镇
            </div>
            <div class="text">尊享买方投教服务</div>
          </div>
        </div>
        <div class="lis3">
          <div class="left">
            <img src="../../assets/img/pagess/gdd102/w3-1.png" alt="" />
          </div>
          <div class="right">
            <div class="t1">
              <img src="../../assets/img/pagess/gdd102/w3-2.png" alt="" />
              <img src="../../assets/img/pagess/gdd102/w3-3.png" alt="" />
            </div>
            <div class="t2">
              <img src="../../assets/img/pagess/gdd102/w3-4.png" alt="" />
              <img src="../../assets/img/pagess/gdd102/w3-5.png" alt="" />
              <img src="../../assets/img/pagess/gdd102/w3-6.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bar" v-if="res">
      <div class="w">
        <div class="text"><span> 下载股多多</span>·助您赢得投资第一桶金</div>
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd102/btn3.png"
          alt=""
        />
      </div>
    </div>
    <div class="bottomrs">
      <div class="text1">—— 投资有风险 入市需谨慎 ——</div>
      <div class="text2" style="margin-top:10px">
        从事证券投资或期货交易，请通过合法证券期货经营机构进行
        合法机构名单可到中国证监会网站(www.csrc.gov.cn)查询
      </div>
      <div class="text2" style="margin-top:10px">
        公司：北京天相财富管理顾问有限公司
      </div>
      <div class="text2" style="margin-top:10px">
        业务资格许可证编号：91110102MA001GJE1N
      </div>
      <div class="text2" style="margin-top:10px">
        股多多软件版本号：v1.4.0.0 更新时间：2022年7月16日
      </div>
      <div class="text3" style="margin-top:15px">
        <span @click="open_yinsi()" style="margin-right: 15px;"
          >隐私保护政策</span
        >
        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </div>
      <div class="text2" style="margin-top:10px;color: aquamarine;">
        开发者名称:北京天相财富管理顾问有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a
          href="https://beian.miit.gov.cn/#/Integrated/index"
        >
          京ICP备16068579号-1</a
        >
      </div>
    </div>
    <div class="boxx"></div>
    <!-- ------------------------------蒙层 -->
    <div class="divBG" @click="tanss()" v-if="tan">
      <div class="content">
        <div class="tan">
          <div class="btnss">
            <img
              class="btn"
              @click="to_xaizai()"
              src="../../assets/img/pagess/gdd102/btn4.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      res: false,
      tan: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScrollx, true);
    this.clientIp();
    setTimeout(() => {
      this.tan = true;
    }, 15000);
  },
  methods: {
    close() {
      this.tan = false;
    },
    tanss() {
      if (this.tan == true) {
        this.tan = false;
      } else {
        this.tan = true;
      }
    },
    handleScrollx() {
      if (this.$refs.obtain.getBoundingClientRect().top < 890) {
        this.res = true;
      } else {
        this.res = false;
      }
    },
    open_yinsi() {
      window.open("https://cdn.juniubang.com/apk/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://cdn.juniubang.com/apk/许可使用协议4.7.pdf");
    },
    changebar(index) {
      this.active = index;
    },
    to_xaizai() {
      // this.post_leilei_data();
      // window.open("https://cdn.juniubang.com/apk/GDD2002.exe");
      this.tan = false;
    },
    // 给磊磊传页面数据
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          qhclickid: this.$route.query.qhclickid,
          url: window.location.href,
          code: this.$route.query.code,
          type: "360"
        })
        .then(res => {});
        window.open(res.data.message);
    },

    clientIp() {
      this.$http.post("/client_ip", { url: window.location.href }).then(res => {
        window.localStorage.setItem("_number", res.data);
      });
    }
  }
};
</script>
<style lang="less" scoped>
// 蒙层
.divBG {
  background-color: rgba(31, 30, 30, 0.6);
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 20;
  .content {
    width: 10px;
    margin: 0 auto;
    position: relative;
  }

  .tan {
    width: 620px;
    height: 412px;
    position: absolute;
    top: 50%;
    left: 50%;
    background: url(../../assets/img/pagess/gdd102/tan.png) no-repeat center;
    z-index: 999;
    margin: 206px 0 0 -310px;
    .btnss {
      padding-top: 355px;
      padding-left: 225px;
    }
  }
}

.h1 {
  width: 100%;
  height: 657px;
  background: url(../../assets/img/pagess/gdd102/banner.png) no-repeat center;
  .w1 {
    width: 1200px;
    margin: 0 auto;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 18px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
  .heng {
    width: 100%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.3);
  }
  .w {
    width: 1200px;
    height: 598px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .l {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      .lis1 {
        padding-top: 79px;
      }
      .lis2 {
        color: rgba(255, 255, 255, 1);
        font-size: 36px;
        font-weight: 400;
      }
      .lis3 {
        margin-top: 38px;
      }
      .lis4 {
        font-size: 24px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-top: 38px;
      }
      .lis5 {
        margin-top: 37px;
      }
    }
    .r {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .lis1 {
        padding-top: 111px;
        margin-bottom: 38px;
      }
    }
  }
}
.h2 {
  width: 100%;
  height: 4178px;
  background: -webkit-linear-gradient(#395f7d, #2c4e69, #153045);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(#395f7d, #2c4e69, #153045);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(#395f7d, #2c4e69, #153045);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(#395f7d, #2c4e69, #153045);
  .w1 {
    width: 1200px;
    margin: 0 auto;
    height: 634px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .lis1 {
      padding-top: 75px;
      margin-bottom: 37px;
      .sss {
        width: 626px;
        height: 119px;
        background: url(../../assets/img/pagess/gdd102/h2-1.png);
        display: flex;
        flex-direction: column;
        align-items: center;

        .text1 {
          color: rgba(255, 255, 255, 1);
          font-size: 32px;
          font-weight: 400;
          padding-top: 19px;
        }
        .text2 {
          color: rgba(255, 255, 255, 1);
          font-size: 24px;
          font-weight: 400;
          margin-top: 10px;
        }
      }
    }
    .lis2 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .liss {
        width: 279px;
        height: 198px;
        background: url(../../assets/img/pagess/gdd102/h2-2.png);
        display: flex;
        flex-direction: column;
        align-items: center;
        .img1 {
          padding-top: 14px;
        }
        .text1 {
          font-size: 15px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          margin-top: 15px;
          span {
            font-weight: 600;
          }
        }
      }
    }
    .lis3 {
      margin-top: 50px;
      display: flex;
      align-items: center;
      span {
        font-size: 24px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-left: 10px;
      }
    }
    .lis4 {
      width: 196px;
      height: 48px;
      background: rgba(121, 72, 234, 1);
      font-size: 24px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 48px;
      margin-top: 15px;
      border-radius: 10px;
    }
  }
  .w2 {
    width: 1200px;
    height: 2364px;
    margin: 0 auto;
    background: -webkit-linear-gradient(#2d5a82, #284965, #1b4367);
    /*  Safari 5.1 到 6.0 */
    background: -o-linear-gradient(#2d5a82, #284965, #1b4367);
    /*  Opera 11.6 到 12.0 */
    background: -moz-linear-gradient(#2d5a82, #284965, #1b4367);
    /*  Fx 3.6 到 15 */
    background: linear-gradient(#2d5a82, #284965, #1b4367);
    display: flex;
    flex-direction: column;
    align-items: center;
    .lis1 {
      padding-top: 70px;
      margin-bottom: 50px;
      .sss {
        width: 626px;
        height: 119px;
        background: url(../../assets/img/pagess/gdd102/h2-1.png);
        display: flex;
        flex-direction: column;
        align-items: center;

        .text1 {
          color: rgba(255, 255, 255, 1);
          font-size: 32px;
          font-weight: 400;
          padding-top: 23px;
          span {
            font-weight: 600;
          }
        }
        .text2 {
          color: rgba(255, 255, 255, 1);
          font-size: 24px;
          font-weight: 400;
          margin-top: 10px;
        }
      }
    }
    .lis2 {
      .liss1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 50px;
        .text1 {
          font-size: 24px;
          font-weight: 700;
          color: rgba(255, 255, 255, 1);
        }
        .text2 {
          font-size: 21px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }
      .liss2 {
        width: 944px;
        display: flex;
        align-items: center;
        .l {
          width: 376px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 96px;
          span {
            padding-top: 77px;
            font-size: 24px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 10px;
          }
          img {
            margin-bottom: 20px;
          }
          .lis-1 {
            width: 376px;
            height: 246px;
            background: url(../../assets/img/pagess/gdd102/h2-10.png);
            font-size: 21px;
            color: rgba(255, 255, 255, 1);
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
      }
      .liss3 {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 50px;
        margin-bottom: 15px;
        span {
          font-size: 24px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          margin-left: 5px;
        }
      }
      .liss4 {
        width: 196px;
        height: 48px;
        line-height: 48px;
        background: rgba(121, 72, 234, 1);
        border-radius: 10px;
        font-size: 24px;
        text-align: center;
        margin: 0 auto;
        color: rgba(255, 255, 255, 1);
      }
    }
    .lis3 {
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 50px;
      .liss1 {
        font-size: 24px;
        font-weight: 700;
        color: rgba(255, 255, 255, 1);
      }
      .liss2 {
        font-size: 21px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-top: 10px;
      }
      .liss3 {
        margin-top: 10px;
        margin-bottom: 30px;
      }
      .liss4 {
        display: flex;
        align-items: center;
        .l {
          width: 376px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 128px;
          span {
            padding-top: 93px;
            font-size: 24px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 5px;
          }
          img {
            margin-bottom: 20px;
          }
          .lis-1 {
            width: 376px;
            height: 210px;
            background: url(../../assets/img/pagess/gdd102/h2-14.png);
            font-size: 21px;
            color: rgba(255, 255, 255, 1);
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
      }
      .liss5 {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 50px;
        margin-bottom: 15px;
        span {
          font-size: 24px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          margin-left: 5px;
        }
      }
      .liss6 {
        width: 196px;
        height: 48px;
        line-height: 48px;
        background: rgba(121, 72, 234, 1);
        border-radius: 10px;
        font-size: 24px;
        text-align: center;
        margin: 0 auto;
        color: rgba(255, 255, 255, 1);
      }
    }
    .lis4 {
      .liss1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 30px;
        .text1 {
          font-size: 24px;
          font-weight: 700;
          color: rgba(255, 255, 255, 1);
        }
        .text2 {
          font-size: 21px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }
      .liss2 {
        display: flex;
        align-items: center;
        .l {
          width: 502px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-right: 128px;
          span {
            font-size: 24px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 5px;
          }
          img {
            margin-bottom: 20px;
          }
          .lis-1 {
            width: 376px;
            height: 325px;
            background: url(../../assets/img/pagess/gdd102/h2-13.png);
            font-size: 21px;
            color: rgba(255, 255, 255, 1);
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
      }
      .liss3 {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
        margin-bottom: 15px;
        span {
          font-size: 24px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          margin-left: 5px;
        }
      }
      .liss4 {
        width: 196px;
        height: 48px;
        line-height: 48px;
        background: rgba(121, 72, 234, 1);
        border-radius: 10px;
        font-size: 24px;
        text-align: center;
        margin: 0 auto;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .w3 {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .lis1 {
      padding-top: 50px;
      font-size: 31px;
      font-weight: 700;
      color: rgba(255, 255, 255, 1);
      margin-bottom: 45px;
    }
    .lis2 {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .qq {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          margin-bottom: 10px;
        }
        .text {
          font-size: 24px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .lis3 {
      margin-top: 48px;
      width: 1200px;
      height: 666px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .right {
        height: 666px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .t2 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
  }
}
.bar {
  width: 100%;
  height: 158px;
  background: url(../../assets/img/pagess/gdd102/bar.png) no-repeat center;
  position: fixed;
  bottom: 0;
  .w {
    height: 100%;
    width: 1200px;
    margin: 0 auto;
    font-size: 45px;
    font-weight: 400;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-weight: 600;
    }
    .btn {
      margin-left: 40px;
    }
  }
}
.boxx {
  width: 100%;
  height: 210px;
  background: rgba(19, 31, 40, 1);
}
.bottomrs {
  width: 100%;
  height: 350px;
  text-align: center;
  background: rgba(19, 31, 40, 1);
  color: white;
  .text1 {
    font-size: 16px;
    font-weight: 500;
    padding-top: 50px;
    text-align: center;
  }
  .text3 span {
    color: #0091ff;
    text-decoration: underline;
  }
  .text3 span:hover {
    color: #f59504;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/gdd102.vue